import React from 'react'

function ProjectGroupExpanding() {
  return (
    <div>ProjectGroupExpanding</div>
  )
}

export default ProjectGroupExpanding